<div class="qa-signature-options">
  <div class="qa-signature-type input-group">
    <span class="input-group-addon">{{_(KEYS.EDITOR.TYPE_OF_SIGNATURE)}}</span>
    <select class="form-control qa-custom-select" [(ngModel)]="question.displayType">
      <option value="canvas">myMedax</option>
      <option value="pdf">SignoSign</option>
    </select>
  </div>
</div>
